<template>
  <div v-if="disablePortalAtBreakpoint">
    <slot></slot>
  </div>
  <portal v-else-if="isSlideInActive(name)" to="slide-in-content">
    <div class="portal-wrapper__container">
      <div v-if="$slots.title" class="portal-wrapper__title">
        <slot name="title"></slot>
      </div>
      <slot></slot>
    </div>
  </portal>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    breakpoint: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters('ui', ['isSlideInActive']),
    disablePortalAtBreakpoint() {
      if(this.breakpoint) {
        return this.mq(this.breakpoint)
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss">
.portal-wrapper__container {
  background-color: color(white);
  width: 100%;
  height: 100%;
  padding: measure(half);
  overflow: auto;
}

.portal-wrapper__title {
  @include h3-bold;
  padding-bottom: measure(half);
  border-bottom: 1px solid color(border-gray);
  margin-bottom: measure(full);
}

</style>
